import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MaterialItemsState, MaterialItemsStore } from './material-items.store';
import { TableColumn } from '../../../models/table-column';
import { ExpensesFilterOptionsModel } from '../../../models/expenses/expenses-filter-options.model';
import {ISavedListSettingsQuery} from '../../../interfaces/settings/saved-list-settings.query';
import {getMaterialFilterOptions, getTableColumns} from './material-table-columns';
import {state} from '@angular/animations';

@Injectable({
  providedIn: 'root',
})
export class MaterialItemsQuery extends QueryEntity<MaterialItemsState> implements ISavedListSettingsQuery {
  page$: Observable<number>;
  pageSize$: Observable<number>;
  columns$: Observable<TableColumn[]>;
  lastPage$: Observable<boolean>;
  filterOptions$: Observable<ExpensesFilterOptionsModel>;
  filterValue$: Observable<string>;

  constructor(protected store: MaterialItemsStore) {
    super(store);
    this.lastPage$ = this.select((state) => state.lastPage);
    this.filterOptions$ = this.select((state) => state.filterOptions);
    this.filterValue$ = this.select((state) => state.filterValue);
    this.page$ = this.select((state) => state.page);
    this.pageSize$ = this.select((state) => state.pageSize);
    this.columns$ = this.select((state) => state.columns);
  }

  filterOptions(): any {
    return this.store.getValue()?.filterOptions;
  }

  getFilterColumns(): TableColumn[] {
    return null;
  }

  getInitialColumns(): TableColumn[] {
    return getTableColumns();
  }

  getTableColumns(): TableColumn[] {
    return this.store.getValue()?.columns;
  }

  newFilterStructure(): boolean {
    return false;
  }

  getInitialFilter(): any {
    return getMaterialFilterOptions();
  }

  hasFilter(): boolean {
    return true;
  }


}
